import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import { withRouter } from 'react-router-dom';
import * as InviteSupplierStateController from '../../store/StateControllers/Supplier/InviteSuppliersStateController';
import StartExperienceGuideComponent from '../Start/StartExperienceGuideComponent';
import InviteSuppliersCore, { InviteSuppliersProps } from './InviteSuppliersCore';
import { ToxnotSignInRequiredComponent } from '../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';

import './styles.css';
import { TeamRole } from '../../store/Models/UserContext';

// ===============================================================================

//
// Renders the main component for Inviting Suppliers.
//

class InviteSuppliers extends ToxnotSignInRequiredComponent<InviteSuppliersProps> {

    // ===============================================================================
    
    public renderConcreteComponent() {
        return (
            <div id="invite-suppliers-full-content" className="tn-section-flex-container">
                <StartExperienceGuideComponent renderAsTnSection={true} localizedHeader={this.localizeString("Ask your Suppliers for Product & Material Passports by sending surveys")}>
                    <p>{this.localizeString("Request material composition, compliance, sustainability, circularity, certifications, or create your own questions with custom questionnaires. The answers will be shared in a the form of Product & Material Passports.")}</p>
                    <p>{this.localizeString("Pick a template, add your suppliers' name and email, add your material names.")}</p>
                    <p>{this.localizeString("3E Exchange will email your suppliers with requests for Product & Material Passports which they can fill out for free on 3E Exchange.")}</p>
                    <p>{this.localizeString("You'll be notified when they share their data. That's it!")}</p>
                </StartExperienceGuideComponent>
                <InviteSuppliersCore shouldMakeTnSection={true} />
            </div>
        );
    }
    // ===============================================================================

    protected override getDisallowedRoles() {
        return [TeamRole.Marketing];
    }
}

// ===============================================================================

export default connect(
    (state: ApplicationState) => ({ ...state.inviteSuppliersState, appServices: state.appServices }),
    InviteSupplierStateController.actionCreators // Selects which action creators are merged into the component's props
)(withRouter(InviteSuppliers) as any);

